import { HttpClient } from "@angular/common/http";
import {
    AfterViewInit,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
} from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";

@Component({
    selector: "app-prelungire-acorduri-functionare",
    templateUrl: "./prelungire-acorduri-functionare.component.html",
    styleUrls: ["./prelungire-acorduri-functionare.component.scss"],
})
export class PrelungireAcorduriFunctionareComponent
    implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
    @Input() type_slug!: string;
    @Input() dataTableParams!: any;
    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    isLoading = false;

    dtLink =
        environment.interop.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderou
            .borderouList;

    constructor(private http: HttpClient) { }

    ngOnInit(): void {
        this.renderDT();
    }
    ngAfterViewInit(): void {
        this.dtTrigger.next("");
    }
    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[0, "desc"]],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.type_slug = this.type_slug;
                dataTablesParameters.date = this.dataTableParams.formattedDate;

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: "Nr crt",
                    data: "id",
                    sortable: false,
                },
                {
                    title: "Nr/Data Cerere",
                    data: null,
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
							<div style="display: flex; align-items: center; gap: 5px; width:200px" >
                                <span>${row.cerere_numar ? row.cerere_numar : "N/A"}</span>
                                <span>/</span>
                                <span style="padding: 2px 4px; background-color: #bdbdbd; border: 0px;border-radius:10px">${row.cerere_data}</span>
							</div>
						`;
                    },
                },
                {
                    title: "Denumire Societate",
                    data: "f_denumire_institutie",
                    sortable: false,
                },
                {
                    title: "Adresa Sediu",
                    data: "sediu",
                    sortable: false,
                },
                {
                    title: "Adresa Punct lucru",
                    data: "punct_lucru",
                    sortable: false,
                },
                {
                    title: "CAEN",
                    data: "f_cod_caen",
                    sortable: false,
                },
                {
                    title: "Nr Acord",
                    data: "acord_numar",
                    sortable: false,
                },
                {
                    title: "Denumire Administrator",
                    data: "denumire_cetatean",
                    sortable: false,
                },
            ],
        };
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });
    }
}
